import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import FaultyCombinationsViewModel from "viewModels/users/accessRights/faultyCombinations/faultyCombinationsViewModel";
import ListView from "../../../common/list";
import type { ColumnDefinition } from "@frui.ts/dataviews/dist";
import type PermissionAreaWithFaultyCombinationsResponse from "entities/permissionAreaWithFaultyCombinationsResponse";
import FaultyCombinationsFilters from "./faultyCombinationsFilters";

const FaultyCombinationsView: ViewComponent<FaultyCombinationsViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<PermissionAreaWithFaultyCombinationsResponse>[] = [
    {
      title: vm.translateAttribute("name"),
      property: "name",
    },
    {
      title: vm.translateAttribute("faultyCombinations"),
      property: "faultyCombinations",
      valueFormatter: props => {
        if (props.item.faultyCombinations.length === 0) {
          return <span className="text-muted">{vm.translate("noCombinations")}</span>;
        }

        return (
          <>
            {props.item.faultyCombinations.map(area => (
              <div className="d-inline-block bg-danger-light rounded py-1 px-2 mr-2" key={area.areaId}>
                {vm.translateArea(area.areaId)}
              </div>
            ))}
          </>
        );
      },
    },
  ];

  return <ListView vm={vm} showDetailWithList={true} columns={columns} aboveTable={<FaultyCombinationsFilters vm={vm} />} />;
});

registerView(FaultyCombinationsView, FaultyCombinationsViewModel);
